
<footer class="footer clearfix">
  <img alt="main logo" src="assets/img/strat-logo-dark.png" class="logo">
  <span class="versionTextClassInner">{{app.versionText}} </span>
  <div class="footer-right">
    <span>{{app.copyRightText}}</span>
  </div>
</footer>